import { render, staticRenderFns } from "./FileTemaplateadjustment.vue?vue&type=template&id=31054c99"
import script from "./FileTemaplateadjustment.vue?vue&type=script&lang=js"
export * from "./FileTemaplateadjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports